import React, { useMemo } from 'react';
var IfElseComponent = function (_a) {
    var condition = _a.condition, children = _a.children, falseComponent = _a.falseComponent;
    var renderContent = useMemo(function () {
        if (condition) {
            return React.createElement(React.Fragment, null, children);
        }
        else {
            if (falseComponent) {
                return falseComponent;
            }
            else {
                return null;
            }
        }
    }, [children, condition, falseComponent]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { IfElseComponent };
//# sourceMappingURL=IfElseComponent.js.map